import { render, staticRenderFns } from "./NormalSearchNav82.vue?vue&type=template&id=15965cb2&scoped=true&"
import script from "./NormalSearchNav82.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav82.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15965cb2",
  null
  
)

export default component.exports